// src/config/hazardVisibility.js
export const HAZARD_VISIBILITY = {
  Routine: false,
  Flooding: true,
  Hurricane: false,
  "Severe Storms": true,
  Tornado: false,              // hide for now
  Wildfire: true,
  "Winter Weather": true,
  "Extreme Heat": false,
  "Extreme Cold": false,
  "High Winds": false,
  "Dense Fog": false,
  "Surf & Rip Currents": false,
};
